import React from 'react';
import { isoMoment, getTimeLeftToOpenVisit } from '../utilities/commonUtilities/dateTools';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { CardItem } from '../utilities/commonUtilities/CardItem';
import { image } from '../home/TaskHome';
import DoneBadge from '../../resources/images/done-badge.svg';
import { ReactComponent as BloodBadge } from '../../resources/images/blood-badge.svg';
import { ReactComponent as ImagingBadge } from '../../resources/images/imaging-big-badge.svg';
import { ReactComponent as BloodAndImagingBadge } from '../../resources/images/blood-and-imaging-badge.svg';
import RocketCardBadge from '../../resources/images/rocket-card.svg';
import CheckCardBadge from '../../resources/images/check-card.svg';
import TimeOffCardBadge from '../../resources/images/time-off-card.svg';
import { isTaskPresent } from '../../utils/VisitTaskHandler';
import * as TaskNames from '../home/TaskNames';
import moment from 'moment';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { setMobileCalendarTestInfo } from '../../actions';
import { PATH_CALENDAR_INFO } from '../../containers/RoutePaths';
import { useHistory } from 'react-router-dom';
import { persistCalendarMobileTestInfo } from '../../utils/ClientSessionHandler';
import { ICON_NAMES } from './CalendarDesktop';
import CardContent from '@material-ui/core/CardContent';
import { Card } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    yearHeading: {
        fontSize: '17px',
        lineHeight: '23px',
    },
    yearVisitsComponent: {
        marginBottom: theme.spacing(3.75),
    },
    visitCard: {
        marginTop: theme.spacing(1),
    },
    sticky: {
        position: 'sticky',
        top: '0px',
        background: theme.palette.background.default,
        zIndex: 1,
    },
    journeyMilestoneCard: {
        position: 'relative',
        marginBottom: theme.spacing(4) - 2,
        boxShadow: 'none',
    },
    journeyMilestoneBadge: {
        position: 'absolute',
        zIndex: '0',
    },
    journeyMilestoneRocketBadge: {
        right: -theme.spacing(2.5),
        top: -theme.spacing(2.5),
    },
    journeyMilestoneCheckBadge: {
        right: -theme.spacing(6.5),
        top: -theme.spacing(5.75),
    },
    journeyMilestoneTimeOffBadge: {
        right: theme.spacing(0),
        top: theme.spacing(0),
    },
    journeyMilestoneContent: {
        position: 'relative',
        padding: theme.spacing(3),
        width: 'calc(100% - 142px)',
        minWidth: theme.spacing(23.5),
    },
    journeyMilestoneTitle: {
        fontSize: theme.spacing(2),
        marginBottom: '2px',
    },
    journeyMilestoneSubtitle: {
        textTransform: 'uppercase',
        fontSize: theme.spacing(1.25),
        marginBottom: theme.spacing(1),
    },
    journeyMilestoneMessage: {
        fontSize: theme.spacing(2),
    },
    journeyMilestoneTall: {
        minHeight: theme.spacing(20.375),
    },
    journeyMilestoneShort: {
        minHeight: theme.spacing(15.375),
    },
    journeyMilestoneTimeOffCard: {
        minHeight: theme.spacing(18),
        marginTop: theme.spacing(1),
        backgroundColor: theme.palette.primary.light,
        borderRadius: theme.spacing(0.5) + 1,
    },
}));

export const monthShortForm = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

const CalendarMobile = ({ visits, dateOfDiagnosis, endOfTreatementDate, yearCount, year, monthIndx, configureTestInfoPage }) => {
    const yearMarkers = generateYearMarkers(dateOfDiagnosis, endOfTreatementDate);
    const yearVisitMap = generateYearVisitMap(yearMarkers, visits);
    const classes = useStyles();

    return (
        <Box>
            <CalendarStartEndCard
                className={classes.journeyMilestoneTall}
                date={dateOfDiagnosis}
                title="Date of Diagnosis"
                message="This is the very start of your journey."
            >
                <img
                    src={RocketCardBadge}
                    alt="Date of Diagnosis Card"
                    className={clsx([classes.journeyMilestoneBadge, classes.journeyMilestoneRocketBadge])}
                />
            </CalendarStartEndCard>
            {yearVisitMap.map((yearVisits, indx) => (
                <YearVisitsComponent key={indx} indx={indx} yearVisits={yearVisits} configureTestInfoPage={configureTestInfoPage} />
            ))}
            <CalendarStartEndCard className={classes.journeyMilestoneShort} title="End of Journey" message="That's it, that's all! Well done.">
                <img src={CheckCardBadge} alt="End of Journey Card" className={clsx([classes.journeyMilestoneBadge, classes.journeyMilestoneCheckBadge])} />
            </CalendarStartEndCard>
        </Box>
    );
};

const YearVisitsComponent = ({ indx, yearVisits, configureTestInfoPage }) => {
    const classes = useStyles();
    return (
        <Box className={classes.yearVisitsComponent}>
            <Typography variant="h2" className={clsx(classes.yearHeading, classes.sticky)}>
                {`Year ${indx + 1}`}
            </Typography>
            {Array.isArray(yearVisits) && yearVisits.length !== 0 ? (
                <YearVisitCards visits={yearVisits} configureTestInfoPage={configureTestInfoPage} yearIndx={indx} />
            ) : (
                <CalendarStartEndCard
                    className={classes.journeyMilestoneTimeOffCard}
                    title="Time Off"
                    message="You don't have any tasks this year, so enjoy it!"
                >
                    <img src={TimeOffCardBadge} alt="Time Off Card" className={clsx([classes.journeyMilestoneBadge, classes.journeyMilestoneTimeOffBadge])} />
                </CalendarStartEndCard>
            )}
        </Box>
    );
};

const YearVisitCards = ({ visits, configureTestInfoPage, yearIndx }) => {
    const classes = useStyles();
    const history = useHistory();

    function onClickHandler(monthIndx, year, iconName) {
        configureTestInfoPage(yearIndx + 1, year, monthIndx, iconName);
        persistCalendarMobileTestInfo({
            yearCount: yearIndx + 1,
            year,
            monthIndx,
            iconName,
        });
        history.push(PATH_CALENDAR_INFO);
    }

    return (
        <>
            {visits.map((visit, indx) => {
                const bloodWorkPresent = isTaskPresent(visit, TaskNames.LAB_WORK);
                const imagingPresent = isTaskPresent(visit, TaskNames.IMAGING);
                let TestBadge;
                let iconName;
                if (bloodWorkPresent && imagingPresent) {
                    TestBadge = BloodAndImagingBadge;
                    iconName = ICON_NAMES.bloodAndImaging;
                } else if (bloodWorkPresent) {
                    TestBadge = BloodBadge;
                    iconName = ICON_NAMES.blood;
                } else if (imagingPresent) {
                    TestBadge = ImagingBadge;
                    iconName = ICON_NAMES.imaging;
                } else {
                    TestBadge = null;
                    iconName = '';
                }

                const { title1, title2 } = getVisitCardTitles(bloodWorkPresent, imagingPresent);
                const monthIndx = isoMoment(visit.taskOpenDate).month();
                const year = isoMoment(visit.taskOpenDate).year();

                return (
                    <CardItem
                        Badge={visit.visitState === 'CLOSED' ? image(DoneBadge, 'done badge') : TestBadge}
                        title={title1}
                        title2={title2}
                        subtitle={visit.visitState === 'CLOSED' ? 'Completed' : `${monthShortForm[monthIndx]} ${year}`}
                        subtitle2={getTimeLeftToOpenVisit(isoMoment(visit.taskOpenDate))}
                        onClick={() => {
                            if (visit.visitState !== 'CLOSED') {
                                onClickHandler(monthIndx, year, iconName);
                            }
                        }}
                        key={indx}
                        className={classes.visitCard}
                        noHoverEffect={true}
                    />
                );
            })}
        </>
    );
};

const CalendarStartEndCard = ({ className, title, date, message, children }) => {
    const classes = useStyles();

    return (
        <Card className={clsx(classes.journeyMilestoneCard, { [className]: className })}>
            {children}
            <CardContent className={classes.journeyMilestoneContent}>
                <Typography className={classes.journeyMilestoneTitle} variant="h3" component="div">
                    {title}
                </Typography>
                {date && <Typography className={classes.journeyMilestoneSubtitle}>{date.format('MMMM Do YYYY')}</Typography>}
                <Typography className={classes.journeyMilestoneMessage}>{message}</Typography>
            </CardContent>
        </Card>
    );
};

function getVisitCardTitles(bloodWorkPresent, imagingPresent) {
    let title1 = null;
    let title2 = null;

    if (bloodWorkPresent) {
        title1 = 'Get a blood test';
        if (imagingPresent) {
            title2 = 'Get an imaging test';
        }
    } else if (imagingPresent) {
        title1 = 'Get an imaging test';
    }

    return { title1, title2 };
}

function generateYearVisitMap(yearMarkers, visits) {
    const yearVisitMap = [];
    for (let i = 0; i < yearMarkers.length - 1; i++) {
        yearVisitMap.push(addVisitsOfYear(yearMarkers[i], yearMarkers[i + 1], visits));
    }
    return yearVisitMap;
}

function addVisitsOfYear(firstYearMarker, secondYearMarker, visits) {
    const yearVisits = [];
    for (const visit of visits) {
        const visitOpenDate = isoMoment(visit.taskOpenDate);
        visitOpenDate.isSameOrAfter(firstYearMarker) && visitOpenDate.isSameOrBefore(secondYearMarker) && yearVisits.push(visit);
    }
    return yearVisits;
}

function generateYearMarkers(dateOfDiagnosis, endOfTreatementDate) {
    const yearMarkers = [dateOfDiagnosis];
    let newMarker = moment(dateOfDiagnosis).add(1, 'y');
    while (newMarker.isBefore(endOfTreatementDate)) {
        yearMarkers.push(newMarker);
        newMarker = moment(newMarker).add(1, 'y');
    }
    yearMarkers.push(endOfTreatementDate);

    return yearMarkers;
}

export const mapStateToProps = state => {
    return {
        yearCount: state?.calendar?.mobileTestInfo?.yearCount,
        year: state?.calendar?.mobileTestInfo?.year,
        monthIndx: state?.calendar?.mobileTestInfo?.monthIndx,
        iconName: state?.calendar?.mobileTestInfo?.iconName,
    };
};

export const mapDispatchToProps = dispatch => {
    const configureTestInfoPage = (yearCount, year, monthIndx, iconName) => {
        dispatch(setMobileCalendarTestInfo(yearCount, year, monthIndx, iconName));
    };
    return {
        configureTestInfoPage,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarMobile);
